<header class="topbar">
  <div class="topbar__left">
    <button
      pButton
      type="button"
      icon="pi pi-bars"
      class="p-button-text"
      (click)="toggleSidebar.emit()"
    ></button>
    <div class="topbar__brand">
      <span class="brand-mark">F</span>
      <a
        class="brand-manual"
        routerLink="/manual"
        aria-label="Abrir manual do sistema"
        title="Manual do sistema"
      >
        <i class="pi pi-book"></i>
      </a>
      <div class="brand-text">
        <strong>Fortaris</strong>
        <small>Sistema de Gestão de Obras</small>
      </div>
    </div>
  </div>

  <div class="topbar__right">
    <p-menu #menuUsuario [model]="menuItens" popup="popup" appendTo="body"></p-menu>
    @if (mostrarBotaoVoltar()) {
      <app-botao-voltar
        class="topbar__back"
        [urlDestino]="urlListagemAtual()"
        [controlarVoltar]="true"
        ariaLabel="Voltar para listagem"
        (aoVoltar)="voltarParaListagem()"
      ></app-botao-voltar>
    }
    @if (sessaoRestante) {
      <div class="topbar__session" [class.topbar__session--critica]="sessaoCritica">
        Sessão: {{ sessaoRestante }}
      </div>
    }
    <button
      pButton
      type="button"
      class="p-button-text topbar__user-trigger"
      (click)="menuUsuario.toggle($event)"
    >
      <span class="topbar__user-inicials">{{ iniciaisUsuario }}</span>
      <span class="topbar__user-name">{{ usuario?.nome }}</span>
      <i class="pi pi-angle-down"></i>
    </button>
  </div>
</header>

<p-dialog
  header="Meu perfil"
  [(visible)]="dialogPerfilAberto"
  [modal]="true"
  [style]="{ width: '560px', maxWidth: '92vw' }"
  [breakpoints]="{ '960px': '90vw' }"
  [contentStyle]="{ maxHeight: '70vh' }"
  [closable]="true"
  [draggable]="false"
  styleClass="fortaris-dialog fortaris-dialog--perfil"
>
  <p class="dialog-subtitle">Revise suas informações antes de salvar.</p>
  <app-formulario-padrao
    [modo]="formPerfil.disabled ? 'Visualização' : 'Edição'"
    [secoes]="secoesPerfil"
    [formExterno]="formPerfil"
    [mostrarAcoes]="false"
    [registrarBotaoVoltarTopbar]="false"
  ></app-formulario-padrao>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-secondary" label="Fechar" (click)="dialogPerfilAberto = false"></button>
    @if (!formPerfil.disabled) {
      <button
        pButton
        type="button"
        label="Salvar"
        [loading]="carregandoPerfil"
        (click)="salvarPerfil()"
      ></button>
    }
  </ng-template>
</p-dialog>

<p-dialog
  header="Alterar senha"
  [(visible)]="dialogSenhaAberto"
  [modal]="true"
  [style]="{ width: '600px', maxWidth: '92vw' }"
  [breakpoints]="{ '960px': '90vw' }"
  [contentStyle]="{ maxHeight: '70vh' }"
  [closable]="true"
  [draggable]="false"
  styleClass="fortaris-dialog fortaris-dialog--senha"
>
  <p class="dialog-subtitle">Use uma senha forte e mantenha sua conta protegida.</p>
  <app-formulario-padrao
    [modo]="'Edição'"
    [secoes]="secoesSenha"
    [formExterno]="formSenha"
    [mostrarAcoes]="false"
    [registrarBotaoVoltarTopbar]="false"
  ></app-formulario-padrao>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-secondary" label="Cancelar" (click)="dialogSenhaAberto = false"></button>
    <button
      pButton
      type="button"
      label="Salvar"
      [loading]="carregandoSenha"
      (click)="salvarSenha()"
    ></button>
  </ng-template>
</p-dialog>
